module.exports = __webpack_public_path__ + "media/images/dashboard/leaderboard-f62c12c1d08c8f4eecceacfd46f490f8.jpeg";